/* Posterlyy theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var P = window.Posterlyy || { routes: {}, strings: {} };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = P.moneyFormat || '₹{{amount_no_decimals}}';
    cents = Number(cents) || 0;
    function withDelims(n, decimals, thousands, dec) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0];
      // Indian grouping (12,34,567) for INR shops, else groups of 3.
      var grouped;
      if (/₹|Rs|INR/.test(fmt) && whole.length > 3) {
        var last3 = whole.slice(-3);
        var rest = whole.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, thousands);
        grouped = rest + thousands + last3;
      } else {
        grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      }
      return parts[1] ? grouped + dec + parts[1] : grouped;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    }).replace(/\.00(?!\d)/, '');
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Header: solid once scrolled ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 32); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Light / dark toggle ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-theme-toggle]')) return;
    var root = document.documentElement;
    var dark = root.classList.toggle('dark');
    try { localStorage.setItem('pl-theme', dark ? 'dark' : 'light'); } catch (err) {}
  });

  /* ---------- Drawers (menu + cart) ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var panel = $('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-overlay.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function cartDrawer() { return $('[data-cart-drawer]'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-menu]')) { openDrawer($('[data-menu-drawer]')); return; }
    var opener = e.target.closest('[data-open-cart]');
    if (opener && P.cartType !== 'page' && cartDrawer()) {
      e.preventDefault();
      openDrawer(cartDrawer());
      return;
    }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
  });

  /* ---------- Cart (AJAX + Section Rendering API) ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-open-cart]').forEach(function (el) {
      el.setAttribute('aria-label', 'Open cart, ' + count + ' item' + (count === 1 ? '' : 's'));
    });
  }

  function refreshCartDrawer(sectionsHtml) {
    var drawer = cartDrawer();
    if (!drawer) return Promise.resolve();
    var apply = function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
      var panel = $('.drawer__panel', drawer);
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    };
    if (sectionsHtml && sectionsHtml['cart-drawer']) {
      apply(sectionsHtml['cart-drawer']);
      return Promise.resolve();
    }
    return fetch(P.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (json) { apply(json['cart-drawer']); });
  }

  function addToCart(formData) {
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    return fetch(P.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || P.strings.error);
        return json;
      });
    });
  }

  function afterAdd(json) {
    return fetch(P.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (P.cartType === 'page') { window.location.href = P.routes.cart; return; }
        return refreshCartDrawer(json && json.sections).then(function () { openDrawer(cartDrawer()); });
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-add], [data-product-form]')) return;
    if (P.cartType === 'page' && !form.matches('[data-product-form]')) return; // plain post is fine
    var submitter = e.submitter;
    // Let the "Buy it now" / checkout buttons behave normally.
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (errorEl) errorEl.hidden = true;
    addToCart(new FormData(form))
      .then(afterAdd)
      .then(function () {
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
        if (P.cartType === 'page') return;
        if (!cartDrawer()) toast(P.strings.added);
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = btn.hasAttribute('data-sold-out'); }
      });
  });

  // Quantity +/- and remove inside the drawer.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-drawer] [data-line]');
    if (!b) return;
    var drawer = cartDrawer();
    drawer.classList.add('is-loading');
    fetch(P.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.qty)), sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);
        updateCount(cart.item_count);
        return refreshCartDrawer(cart.sections);
      })
      .catch(function (err) { toast(err.message || P.strings.error); })
      .finally(function () { drawer.classList.remove('is-loading'); });
  });

  // Keep the drawer honest when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(P.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); refreshCartDrawer(); });
  });

  /* ---------- Quantity steppers (product page, cart page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = Number(input.min || 0);
    input.value = Math.max(min, (Number(input.value) || 0) + Number(b.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  var cartPageTimer;
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-autosubmit]')) return;
    clearTimeout(cartPageTimer);
    var form = e.target.form;
    cartPageTimer = setTimeout(function () {
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
      form.appendChild(hidden);
      form.submit();
    }, 500);
  });

  /* ---------- Search overlay + predictive search ---------- */
  var overlay = $('[data-search-overlay]');
  function openSearch() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var input = $('[data-search-input]', overlay);
    setTimeout(function () { input && input.focus(); }, 30);
  }
  function closeSearch() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-close-search]')) closeSearch();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); }
  });

  if (overlay) {
    var input = $('[data-search-input]', overlay);
    var results = $('[data-search-results]', overlay);
    var timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        var url = P.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var items = (json.resources && json.resources.results && json.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = '<p class="search-results__empty">Nothing by that name — yet. Try a show, a driver or an artist.</p>';
              return;
            }
            var html = '<div class="search-results__grid">' + items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
              return '<a class="search-hit" href="' + p.url + '">' +
                '<div class="search-hit__img">' + (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') + '</div>' +
                '<p>' + escapeHtml(p.title) + '</p>' +
                '<span>' + (p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a>';
            }).join('') + '</div>' +
              '<p class="search-results__all"><a class="link-u link-u--strong" href="' + P.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">See every result →</a></p>';
            results.innerHTML = html;
          })
          .catch(function () {});
      }, 180);
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- Shelves: hover or scroll flips the active pile ---------- */
  $$('[data-shelves]').forEach(function (root) {
    var rows = $$('[data-shelf-row]', root);
    var piles = $$('[data-shelf-pile]', root);
    if (!rows.length) return;
    var scrollActive = 0, hovered = null;
    function render() {
      var a = hovered === null ? scrollActive : hovered;
      rows.forEach(function (r, i) { r.classList.toggle('is-active', i === a); });
      piles.forEach(function (p, i) { p.classList.toggle('is-active', i === a); });
    }
    rows.forEach(function (r, i) {
      r.addEventListener('mouseenter', function () { hovered = i; render(); });
      r.addEventListener('focus', function () { hovered = i; render(); });
      r.addEventListener('blur', function () { hovered = null; render(); });
    });
    var list = $('.shelves__desktop', root);
    if (list) list.addEventListener('mouseleave', function () { hovered = null; render(); });
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { scrollActive = rows.indexOf(en.target); render(); }
        });
      }, { rootMargin: '-48% 0px -48% 0px', threshold: 0 });
      rows.forEach(function (r) { io.observe(r); });
    }
  });

  /* ---------- Room showcase slider ---------- */
  $$('[data-slider]').forEach(function (root) {
    var slides = $$('[data-slide]', root);
    var caps = $$('[data-slide-caption]', root);
    var links = $$('[data-slide-link]', root);
    var ticks = $$('[data-slide-tick]', root);
    var num = $('[data-slide-num]', root);
    if (slides.length < 2) return;
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      caps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      links.forEach(function (s, k) { s.hidden = k !== i; });
      ticks.forEach(function (s, k) { s.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (num) num.textContent = String(i + 1).padStart(2, '0');
    }
    var prev = $('[data-slide-prev]', root), next = $('[data-slide-next]', root);
    prev && prev.addEventListener('click', function () { go(i - 1); });
    next && next.addEventListener('click', function () { go(i + 1); });
    ticks.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
  });

  /* ---------- Drag to scroll (poster rows) ---------- */
  $$('[data-drag-scroll]').forEach(function (el) {
    var down = false, startX = 0, startLeft = 0, moved = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 4) el.classList.add('is-dragging');
      el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      setTimeout(function () { el.classList.remove('is-dragging'); }, 0);
    });
    // Vertical wheel scrolls the row sideways while hovering on desktop.
    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = el.scrollWidth - el.clientWidth;
      if ((e.deltaY > 0 && el.scrollLeft >= max - 1) || (e.deltaY < 0 && el.scrollLeft <= 0)) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    }, { passive: false });
  });

  /* ---------- In-view triggers (closing fan) ---------- */
  var inviews = $$('[data-inview]');
  if (inviews.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      inviews.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io2.unobserve(en.target); }
        });
      }, { threshold: 0.3 });
      inviews.forEach(function (el) { io2.observe(el); });
    }
  }

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var priceNow = $('[data-price-now]', root);
    var priceWas = $('[data-price-was]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var addArrow = $('[data-add-arrow]', root);
    var stockNote = $('[data-stock-note]', root);
    var fieldsets = $$('[data-option-index]', root);

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined || o === opts[i]; });
      });
    }
    function paint(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('data-sold-out', ''); }
        if (addLabel) addLabel.textContent = P.strings.unavailable;
        if (addArrow) addArrow.hidden = true;
        if (stockNote) stockNote.textContent = '';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) {
        var onSale = v.compare_at_price > v.price;
        priceWas.hidden = !onSale;
        if (onSale) priceWas.textContent = formatMoney(v.compare_at_price);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (v.available) addBtn.removeAttribute('data-sold-out'); else addBtn.setAttribute('data-sold-out', '');
      }
      if (addLabel) addLabel.textContent = v.available ? P.strings.addToCart : P.strings.soldOut;
      if (addArrow) addArrow.hidden = !v.available;
      if (stockNote) {
        if (!v.available) stockNote.innerHTML = 'Sold out — back soon';
        else if (v.tracked && v.qty > 0 && v.qty <= data.lowStock) stockNote.innerHTML = '<span class="low">Only ' + v.qty + ' left of this size</span>';
        else stockNote.textContent = data.shipNote || '';
      }
      // Mark sizes that can't be bought with the other current choices.
      var cur = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = cur.slice(); test[idx] = inp.value;
          var match = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === test[i]; }); });
          inp.closest('.pill').classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (v.media_id) showSlide(String(v.media_id));
      // Keep the URL shareable.
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { paint(findVariant(selectedOptions())); });
    });
    var initial = data.variants.find(function (v) { return idInput && String(v.id) === idInput.value; });
    if (initial) {
      // Don't rewrite the URL on load.
      var rs = history.replaceState; history.replaceState = function () {};
      paint(initial);
      history.replaceState = rs;
    }

    // Stage: thumbnails + cursor tilt with glare.
    var stage = $('[data-stage]', root);
    var tilt = $('[data-stage-tilt]', root);
    function showSlide(mediaId) {
      $$('[data-stage-slide]', root).forEach(function (s) { s.classList.toggle('is-active', s.dataset.stageSlide === mediaId); });
      $$('[data-stage-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t.dataset.stageThumb === mediaId ? 'true' : 'false'); });
    }
    $$('[data-stage-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.dataset.stageThumb); });
    });
    if (stage && tilt && !reduced && window.matchMedia('(pointer: fine)').matches) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        tilt.style.transform = 'rotateX(' + ((py - 0.5) * -14).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 16).toFixed(2) + 'deg)';
        tilt.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        tilt.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      stage.addEventListener('pointerleave', function () {
        tilt.style.transform = '';
        tilt.style.setProperty('--gx', '50%');
        tilt.style.setProperty('--gy', '50%');
      });
    }
  });

  /* ---------- Related products (loaded after the page) ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    var load = function () {
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io3 = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io3.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io3.observe(el);
    } else load();
  });

  /* ---------- Collection filters: apply on change ---------- */
  $$('[data-facets]').forEach(function (form) {
    var t;
    form.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var params = new URLSearchParams(new FormData(form));
        // Drop empty price inputs so they don't count as a filter.
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        // Convert rupees typed in the price boxes to Shopify's expected units.
        window.location.href = form.action + '?' + params.toString();
      }, 350);
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-filters-toggle]');
    if (!b) return;
    var f = document.getElementById(b.getAttribute('aria-controls'));
    var open = f.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
